import React, { memo } from 'react';
import { useLocation } from 'react-router-dom';
import { useStore } from 'store/StoreContext';
import { MenuConst } from 'consts/MenuConst';
import { childNonOperablePaths } from 'consts/RoutePath';
import { MenuLink } from 'components/molecules/menu-link/MenuLink';
import classes from './menu.module.scss';

type Props = {};
export const Menu = memo((_props: Props) => {
	const [store] = useStore();
	const currentPath = useLocation().pathname;

	const excludeKey = store.serviceProhibitionData.use_prohibited_service
		? MenuConst.WITHDRAW.key
		: MenuConst.WITHDRAW_CONTACT_FORM.key;
	const excludedMenuList = Object.values(MenuConst).filter((m) => m.key !== excludeKey);

	const childNonOperablePathsSet = new Set(childNonOperablePaths);
	const menuList = store.loginUserData.isChild
		? excludedMenuList.filter((m) => !childNonOperablePathsSet.has(m.link))
		: excludedMenuList;
	const MenuLength = menuList.length;

	return (
		<div className={classes.menu}>
			{menuList.map((m, i) => {
				const isCurrent = m.link === currentPath;
				const isLast = i === MenuLength - 1;
				return (
					<MenuLink
						label={m.label}
						image={isCurrent ? m.selectedImage : m.image}
						link={isCurrent ? undefined : m.link}
						isLast={isLast}
					/>
				);
			})}
		</div>
	);
});
